import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("web@centrostudiathena.it");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0B192C]">
      <div className="hidden lg:flex flex-col justify-between p-12 text-white relative overflow-hidden">
        <div className="relative z-10 flex items-center gap-3">
          <img src="/logo_csa.jpg" alt="Centro Studi Athena" className="h-11 w-11 rounded-xl bg-white object-contain p-1" data-testid="login-logo" />
          <div className="font-display font-bold text-lg">Centro Studi Athena</div>
        </div>
        <div className="relative z-10">
          <h1 className="text-4xl font-display font-extrabold leading-tight">Registro Presenze<br />Videoconferenza</h1>
          <p className="mt-4 text-slate-300 max-w-md">
            Importazione CSV, aggregazione degli accessi multipli, calcolo della presenza effettiva
            e monitoraggio progressivo delle assenze per i corsi in videoconferenza sincrona.
          </p>
        </div>
        <div className="relative z-10 text-xs text-slate-400">Area riservata — Amministrazione</div>
        <div className="absolute -right-24 -bottom-24 h-96 w-96 rounded-full bg-[#1E3E62]/50 blur-2xl" />
        <div className="absolute right-20 top-20 h-60 w-60 rounded-full bg-[#008C45]/20 blur-3xl" />
      </div>

      <div className="flex items-center justify-center p-6 bg-slate-50">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <img src="/logo_csa.jpg" alt="Centro Studi Athena" className="h-8 w-8 object-contain" />
            <span className="font-display font-bold text-slate-900">Athena Presenze</span>
          </div>
          <h2 className="text-2xl font-display font-bold text-slate-900">Accedi</h2>
          <p className="text-sm text-slate-500 mb-6">Inserisci le tue credenziali amministrative.</p>

          {error && (
            <div data-testid="login-error" className="mb-4 rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm px-3 py-2">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" data-testid="login-email" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} required className="mt-1" />
            </div>
            <Button type="submit" data-testid="login-submit" disabled={loading}
              className="w-full bg-[#0B192C] hover:bg-[#07111E]">
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Entra
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
